import { render } from "./StandardContent.vue?vue&type=template&id=92369a2c"
import script from "./StandardContent.vue?vue&type=script&lang=js"
export * from "./StandardContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__